import styled from "@emotion/styled";

export const ButtonContainer = styled("div")`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  row-gap: 1rem;
  width: 80%;
`;
